import { AuthState } from '@okta/okta-auth-js';

import { Compuweigh } from '../../services/backend/Compuweigh';
import { useBaseApiClient } from '../useBaseApiClient';

export const useCompuweigh: () => Compuweigh<AuthState> = () => {
  return useBaseApiClient(Compuweigh);
};
